/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Category/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Questions from './Questions/index'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Category({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Content/Categories/Category"
  
}) {
let categoryIdValueData = fromData.useDataFormat({ viewPath,
context: 'category',
path: 'id',
format: fromHelpers.getTitle,
})
let categoryQuestionsValueData = fromData.useDataFormat({ viewPath,
context: 'category',
path: 'questions',
format: fromHelpers.getLastModified,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={0}
 data="category_item.indexReverse"
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
>
{childProps => (
<React.Fragment>
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 marginTop={0.1}
 marginBottom={0.1}
 data="category.id"
 format="helpers.js getTitle"
 text={categoryIdValueData}
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 color={dtColorsNeutral700}
 data="category.questions"
 format="helpers.js getLastModified"
 text={categoryQuestionsValueData}
/>
</React.Fragment>
)}
</TysiaCardHeader>
<Questions
{...childProps}
  viewPath={`${viewPath}/Questions`}
/>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}